import React from 'react'
import style from '../../style.module.less'
import store from '../store'
import { getObjValue } from '@hlj/hlj-utils'
import { isStoreAccount } from '@util'

export default is_shop => [
  {
    title: '案例',
    dataIndex: 'name',
    key: 'name',
    render: (text, record) => (
      <div>
        <dl className={style.work}>
          <dt>
            {!is_shop && (
              <cite
                style={{
                  display:
                    record.status == 0 || record.status == 3
                      ? 'inline-block'
                      : 'none'
                }}
                className={style.citeI}
              >
                {record.status == 0
                  ? '审核中'
                  : record.status == 3
                    ? '未通过审核'
                    : ''}
              </cite>
            )}

            <img
              style={{ width: 100, height: 62 }}
              src={record.cover_path + '?imageView2/1/w/100/h/62'}
            />
          </dt>
          <dd>
            <h5>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={'/example/detail_' + record.id + '/admin/true'}
              >
                {is_shop ? (
                  <span>
                    {getObjValue(record, 'set_meal_extend.shop_title')}
                  </span>
                ) : (
                  <span>{record.title}</span>
                )}
              </a>
            </h5>
          </dd>
        </dl>
        <p
          style={{
            display:
              store.key == 2 || store.key == 4
                ? record.reason == '' || record.reason == null
                  ? 'none'
                  : 'block'
                : 'none'
          }}
          className={style.tipBox}
        >
          <span />
          {record.status == 3 ? '未通过原因:' : '优化建议:'}
          {record.reason == '' || record.reason == null ? '' : record.reason}
        </p>
      </div>
    )
  },
  {
    title: '类目',
    dataIndex: 'property_name',
    key: 'property_name',
    hidden: !isStoreAccount()
  },
  {
    title: '收藏数',
    dataIndex: 'num',
    key: 'num',
    render: (text, record) => (
      <div>{record.collectors_count ? record.collectors_count : '-'}</div>
    )
  },
  {
    title: '上架时间',
    dataIndex: 'publish',
    key: 'publish',
    render: (text, record) => <div>{record.published_time}</div>
  },
  {
    title: '操作',
    dataIndex: 'edit',
    key: 'edit',
    render: (text, record, index) => (
      <div className={style.order}>
        <button
          disabled={index == 0}
          onClick={store.orderFn(record.id, index, 'up')}
          style={{ backgroundPositionY: index == 0 ? -42 : 0 }}
        />
        <button
          disabled={index == 19}
          onClick={store.orderFn(record.id, index, 'down')}
          style={{ backgroundPositionY: index == store.length - 1 ? -42 : 0 }}
        />
        <button
          disabled={index == 0}
          onClick={() => store.orderTop(record.id)}
          style={{ backgroundPositionY: index == 0 ? -42 : 0 }}
        />
      </div>
    )
  }
]
